import { useLocation } from 'preact-iso';

import { t } from '@amumin/i18n';
import { Notice } from '@amumin/ui';

import { loginDestination } from '../lib/pairingResume.js';
import { AuthLayout } from '../components/AuthLayout.js';
import { CodeEntry } from '../components/CodeEntry.js';
import {
  messages,
  pendingChallenge,
  setAuthenticated,
  setPendingChallenge,
} from '../state/session.js';

/** E-mailcode na het wachtwoord (regel 4/7 in ONTWERP.md §11.1.1; cookie fb_chal in de browser). */
export function LoginCodePage() {
  const { route } = useLocation();
  const m = messages.value;
  const challenge = pendingChallenge.value;

  if (!challenge) {
    return (
      <AuthLayout title={m.web.codeTitle}>
        <Notice kind="warning">{m.web.noPendingCode}</Notice>
        <p class="auth-links">
          <a href="/login">{m.web.toLogin}</a>
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title={m.web.codeTitle}>
      <CodeEntry
        challenge={challenge}
        intro={t(m.web.codeIntro, { email: challenge.masked_email })}
        showTrust
        showNotMeHint
        onVerified={(ctx) => {
          setPendingChallenge(null);
          setAuthenticated(ctx);
          route(loginDestination(), true);
        }}
        onAbandon={() => {
          setPendingChallenge(null);
          route('/login', true);
        }}
        abandonLabel={m.web.toLogin}
      />
    </AuthLayout>
  );
}
